export function focusNextTabElement(): void {
  const currentElement = document.activeElement as HTMLElement;
  const focusableSelectors = [
    'input:not([disabled]):not([type="hidden"]):not([readonly])',
    'select:not([disabled]):not([readonly])',
    'textarea:not([disabled]):not([readonly])',
    '[tabindex]:not([tabindex="-1"])'
  ];
  const elements = Array.from(document.querySelectorAll(focusableSelectors.join(','))) as HTMLElement[];
  const nextTabElement = elements[elements.indexOf(currentElement) + 1];
  if (nextTabElement) {
    nextTabElement.focus();
  }
}
